import React, { useEffect, useState, useRef } from "react"
import axios from "axios"
import BotaoExportar from "../components/BotaoExportar"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const FORM_VAZIO = {
  tipo_pessoa:"PJ",
  razao_social:"", nome_fantasia:"", cnpj:"", cpf:"", email:"", telefone:"",
  cep:"", logradouro:"", numero:"", complemento:"", bairro:"", cidade:"", estado:"",
  resp1_nome:"", resp1_telefone:"", resp1_email:"",
  resp2_nome:"", resp2_telefone:"", resp2_email:"",
  resp3_nome:"", resp3_telefone:"", resp3_email:"",
  fin_nome:"", fin_telefone:"", fin_emails:"", fin_vencimento:"10",
  observacoes:""
}

export default function Clientes() {
  const [dados, setDados]       = useState<any[]>([])
  const [modal, setModal]       = useState(false)
  const [editando, setEditando] = useState<any>(null)
  const [form, setForm]         = useState<any>(FORM_VAZIO)
  const [busca, setBusca]       = useState("")
  const [loading, setLoading]   = useState(true)
  const [buscandoCNPJ, setBuscandoCNPJ] = useState(false)
  const [buscandoCEP, setBuscandoCEP]   = useState(false)
  const [logoUrl, setLogoUrl]       = useState<string|null>(null)     // logo ja gravada do cliente em edicao
  const [logoNova, setLogoNova]     = useState<File|null>(null)       // logo escolhida num cliente ainda nao salvo
  const [logoPrevia, setLogoPrevia] = useState<string|null>(null)
  const [enviandoLogo, setEnviandoLogo] = useState(false)
  const logoRef = useRef<HTMLInputElement>(null)

  const carregar = async () => {
    try { const r = await axios.get(`${API}/clientes`); setDados(r.data) }
    catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const abrirNovo = () => { setEditando(null); setForm(FORM_VAZIO); setLogoUrl(null); setLogoNova(null); setLogoPrevia(null); setModal(true) }
  const abrirEditar = (c:any) => {
    setEditando(c); setLogoUrl(c.logo_url||null); setLogoNova(null); setLogoPrevia(null)
    setForm({
      tipo_pessoa:c.tipo_pessoa||"PJ",
      razao_social:c.razao_social||"", nome_fantasia:c.nome_fantasia||"",
      cnpj:c.cnpj||c.cpf_cnpj||"", cpf:c.cpf||"", email:c.email||"", telefone:c.telefone||"",
      cep:c.cep||"", logradouro:c.logradouro||"", numero:c.numero||"",
      complemento:c.complemento||"", bairro:c.bairro||"", cidade:c.cidade||"", estado:c.estado||"",
      resp1_nome:c.resp1_nome||"", resp1_telefone:c.resp1_telefone||"", resp1_email:c.resp1_email||"",
      resp2_nome:c.resp2_nome||"", resp2_telefone:c.resp2_telefone||"", resp2_email:c.resp2_email||"",
      resp3_nome:c.resp3_nome||"", resp3_telefone:c.resp3_telefone||"", resp3_email:c.resp3_email||"",
      fin_nome:c.fin_nome||"", fin_telefone:c.fin_telefone||"",
      fin_emails:c.fin_emails||"", fin_vencimento:c.fin_vencimento||"10",
      observacoes:c.observacoes||""
    })
    setModal(true)
  }

  const buscarCNPJ = async () => {
    const cnpj = form.cnpj.replace(/\D/g,"")
    if (cnpj.length !== 14) return alert("CNPJ inválido")
    setBuscandoCNPJ(true)
    try {
      const r = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`)
      if (!r.ok) throw new Error("CNPJ não encontrado")
      const d = await r.json()
      setForm((f:any) => ({...f,
        razao_social: d.razao_social||f.razao_social,
        nome_fantasia: d.nome_fantasia||f.nome_fantasia,
        email: d.email||f.email,
        telefone: d.ddd_telefone_1 ? d.ddd_telefone_1.replace(/\D/g,"") : f.telefone,
        cep: d.cep ? d.cep.replace(/\D/g,"") : f.cep,
        logradouro: d.logradouro||f.logradouro,
        numero: d.numero||f.numero,
        complemento: d.complemento||f.complemento,
        bairro: d.bairro||f.bairro,
        cidade: d.municipio||f.cidade,
        estado: d.uf||f.estado,
      }))
    } catch { alert("CNPJ não encontrado na Receita Federal") }
    finally { setBuscandoCNPJ(false) }
  }

  const buscarCEP = async () => {
    const cep = form.cep.replace(/\D/g,"")
    if (cep.length !== 8) return alert("CEP inválido")
    setBuscandoCEP(true)
    try {
      const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      const d = await r.json()
      if (d.erro) throw new Error("CEP não encontrado")
      setForm((f:any) => ({...f,
        logradouro: d.logradouro||f.logradouro,
        bairro: d.bairro||f.bairro,
        cidade: d.localidade||f.cidade,
        estado: d.uf||f.estado,
      }))
    } catch { alert("CEP não encontrado") }
    finally { setBuscandoCEP(false) }
  }

  // ---- logo do cliente (cabecalho dos relatorios em PDF)
  const erroDaLogo = (f:File) =>
    !["image/png","image/jpeg","image/webp"].includes(f.type) ? "Use uma imagem PNG, JPG ou WebP."
    : f.size > 3*1024*1024 ? "A logo é grande demais (máximo 3 MB)." : null
  const enviarArquivoLogo = async (id:string, f:File) => {
    const fd = new FormData(); fd.append("arquivo", f)
    const r = await axios.put(`${API}/clientes/${id}/logo`, fd)
    return r.data.logo_url as string
  }
  const escolherLogo = async (f:File) => {
    const erro = erroDaLogo(f); if (erro) return alert(erro)
    if (!editando) {                       // cliente novo: envia depois de salvar (so entao ele tem id)
      setLogoNova(f); setLogoPrevia(typeof URL.createObjectURL==="function" ? URL.createObjectURL(f) : null); return
    }
    setEnviandoLogo(true)
    try { setLogoUrl(await enviarArquivoLogo(editando.id, f)); carregar() }
    catch(e:any) { alert(e.response?.data?.erro||"Erro ao enviar a logo") }
    finally { setEnviandoLogo(false) }
  }
  const removerLogo = async () => {
    if (!editando) { setLogoNova(null); setLogoPrevia(null); return }
    if (!window.confirm("Remover a logo deste cliente?")) return
    try { await axios.delete(`${API}/clientes/${editando.id}/logo`); setLogoUrl(null); carregar() }
    catch(e:any) { alert(e.response?.data?.erro||"Erro ao remover a logo") }
  }
  const logoMostrada = editando ? logoUrl : logoPrevia

  const salvar = async () => {
    if (!form.razao_social) return alert("Nome/Razão social é obrigatório")
    if (form.tipo_pessoa==="PJ" && !form.cnpj) return alert("CNPJ é obrigatório para Pessoa Jurídica")
    if (form.tipo_pessoa==="PF" && !form.cpf) return alert("CPF é obrigatório para Pessoa Física")
    if (!form.email) return alert("E-mail é obrigatório")
    if (!form.fin_nome) return alert("Nome do responsável financeiro é obrigatório")
    if (!form.fin_telefone) return alert("Telefone do responsável financeiro é obrigatório")
    if (!form.fin_emails) return alert("E-mail do responsável financeiro é obrigatório")
    try {
      const payload = {
        ...form,
        cpf_cnpj: form.tipo_pessoa==="PJ" ? form.cnpj : form.cpf
      }
      if (editando) await axios.put(`${API}/clientes/${editando.id}`, payload)
      else {
        const r = await axios.post(`${API}/clientes`, payload)
        if (logoNova && r.data?.id) {
          try { await enviarArquivoLogo(r.data.id, logoNova) }
          catch(e:any) { alert(`Cliente salvo, mas a logo não foi enviada: ${e.response?.data?.erro||"erro"}. Edite o cliente para enviar de novo.`) }
        }
      }
      setModal(false); carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const excluir = async (id:string) => {
    if (!window.confirm("Excluir cliente?")) return
    try { await axios.delete(`${API}/clientes/${id}`); carregar() } catch {}
  }

  const filtrados = dados.filter(d =>
    !busca || d.razao_social?.toLowerCase().includes(busca.toLowerCase()) ||
    d.cpf_cnpj?.includes(busca) || d.email?.includes(busca)
  )

  const Secao = ({titulo, icone}: any) => (
    <div style={{gridColumn:"1/-1",borderTop:"1px solid #2d4166",paddingTop:12,marginTop:8}}>
      <div style={{fontSize:12,fontWeight:700,color:"#94a3b8",marginBottom:8}}>{icone} {titulo}</div>
    </div>
  )

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>🏢 Clientes</h2>
          <p style={{fontSize:13,color:"#64748b"}}>{filtrados.length} de {dados.length} registro(s)</p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <BotaoExportar endpoint="clientes" titulo="Clientes" />
          <button className="btn btn-primary" onClick={abrirNovo}>+ Novo cliente</button>
        </div>
      </div>

      <div style={{marginBottom:16}}>
        <input placeholder="Buscar por nome, CNPJ ou e-mail..." value={busca}
          onChange={e=>setBusca(e.target.value)} style={{maxWidth:400}} />
      </div>

      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0d1b2e"}}>
              {["Tipo","Nome / Razão Social","CNPJ/CPF","E-mail","Telefone","Cidade","Status","Ações"].map(h=>(
                <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,
                  color:"#64748b",fontWeight:600,textTransform:"uppercase",letterSpacing:0.5}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{padding:24,textAlign:"center",color:"#64748b"}}>Carregando...</td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan={8} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhum cliente encontrado</td></tr>
            ) : filtrados.map((c:any)=>(
              <tr key={c.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                <td style={{padding:"10px 14px"}}>
                  <span style={{fontSize:10,padding:"2px 6px",borderRadius:6,
                    background:c.tipo_pessoa==="PF"?"#451a03":"#0c2a4a",
                    color:c.tipo_pessoa==="PF"?"#fbbf24":"#38bdf8",
                    border:`1px solid ${c.tipo_pessoa==="PF"?"#f59e0b":"#0ea5e9"}`}}>
                    {c.tipo_pessoa==="PF"?"PF":"PJ"}
                  </span>
                </td>
                <td style={{padding:"10px 14px"}}>
                  <div style={{fontWeight:600,fontSize:13}}>{c.razao_social}</div>
                  {c.nome_fantasia && <div style={{fontSize:10,color:"#64748b"}}>{c.nome_fantasia}</div>}
                </td>
                <td style={{padding:"10px 14px",fontSize:12,fontFamily:"monospace"}}>{c.cpf_cnpj||"—"}</td>
                <td style={{padding:"10px 14px",fontSize:12}}>{c.email}</td>
                <td style={{padding:"10px 14px",fontSize:12}}>{c.telefone||"—"}</td>
                <td style={{padding:"10px 14px",fontSize:12,color:"#94a3b8"}}>{c.cidade||"—"}{c.estado?`/${c.estado}`:""}</td>
                <td style={{padding:"10px 14px"}}>
                  <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,
                    background:c.status==="ativo"?"#14532d":"#1e293b",
                    color:c.status==="ativo"?"#4ade80":"#64748b"}}>
                    {c.status}
                  </span>
                </td>
                <td style={{padding:"10px 14px"}}>
                  <div style={{display:"flex",gap:6}}>
                    <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:12}} onClick={()=>abrirEditar(c)}>✏️</button>
                    <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:12,color:"#f87171"}} onClick={()=>excluir(c.id)}>🗑️</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:700,maxHeight:"92vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <h3>{editando?"✏️ Editar cliente":"🏢 Novo cliente"}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
            </div>

            <div className="form-grid">
              {/* Logo do cliente */}
              <div className="form-group full">
                <label>Logo do cliente</label>
                <div style={{display:"flex",alignItems:"center",gap:14}}>
                  <div style={{width:72,height:72,borderRadius:14,border:"1px solid #2d4166",background:"#fff",display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden",flex:"none"}}>
                    {logoMostrada
                      ? <img src={logoMostrada} alt="Logo do cliente" style={{maxWidth:"100%",maxHeight:"100%",objectFit:"contain"}} />
                      : <span style={{fontSize:26,color:"#94a3b8"}}>🏢</span>}
                  </div>
                  <div>
                    <div style={{display:"flex",gap:8}}>
                      <button type="button" className="btn btn-ghost" disabled={enviandoLogo} onClick={()=>logoRef.current?.click()}>
                        {enviandoLogo ? "Enviando..." : logoMostrada ? "Trocar logo" : "Enviar logo"}
                      </button>
                      {logoMostrada && <button type="button" className="btn btn-ghost" style={{color:"#f87171"}} disabled={enviandoLogo} onClick={removerLogo}>Remover logo</button>}
                    </div>
                    <div style={{fontSize:11,color:"#64748b",marginTop:6}}>Aparece no cabeçalho dos relatórios em PDF. PNG, JPG ou WebP, até 3 MB (de preferência com fundo transparente).</div>
                  </div>
                  <input ref={logoRef} type="file" aria-label="Arquivo da logo" accept="image/png,image/jpeg,image/webp" style={{display:"none"}}
                    onChange={e=>{ const f=e.target.files?.[0]; e.target.value=""; if(f) escolherLogo(f) }} />
                </div>
              </div>

              {/* Tipo de pessoa */}
              <div className="form-group full">
                <label>Tipo de pessoa *</label>
                <div style={{display:"flex",gap:8}}>
                  {[{id:"PJ",label:"🏢 Pessoa Jurídica"},{id:"PF",label:"👤 Pessoa Física"}].map(t=>(
                    <div key={t.id} onClick={()=>setForm({...form,tipo_pessoa:t.id})}
                      style={{flex:1,padding:"10px 16px",borderRadius:8,cursor:"pointer",textAlign:"center",
                        border:`2px solid ${form.tipo_pessoa===t.id?"#0ea5e9":"#2d4166"}`,
                        background:form.tipo_pessoa===t.id?"#0c2a4a":"transparent",
                        color:form.tipo_pessoa===t.id?"#38bdf8":"#94a3b8",fontWeight:form.tipo_pessoa===t.id?700:400,
                        fontSize:13}}>
                      {t.label}
                    </div>
                  ))}
                </div>
              </div>

              {/* CNPJ com consulta */}
              {form.tipo_pessoa==="PJ" && (
                <div className="form-group full">
                  <label>CNPJ *</label>
                  <div style={{display:"flex",gap:8}}>
                    <input value={form.cnpj}
                      onChange={e=>setForm({...form,cnpj:e.target.value})}
                      placeholder="00.000.000/0000-00" style={{flex:1}} />
                    <button type="button" className="btn btn-primary"
                      onClick={buscarCNPJ} disabled={buscandoCNPJ} style={{flexShrink:0}}>
                      {buscandoCNPJ?"🔍 Buscando...":"🔍 Consultar RFB"}
                    </button>
                  </div>
                  <div style={{fontSize:10,color:"#475569",marginTop:3}}>
                    Integração com Receita Federal — preenche automaticamente os dados
                  </div>
                </div>
              )}

              {form.tipo_pessoa==="PF" && (
                <div className="form-group">
                  <label>CPF *</label>
                  <input value={form.cpf} onChange={e=>setForm({...form,cpf:e.target.value})}
                    placeholder="000.000.000-00" />
                </div>
              )}

              <div className="form-group full">
                <label>{form.tipo_pessoa==="PJ"?"Razão Social":"Nome completo"} *</label>
                <input value={form.razao_social} onChange={e=>setForm({...form,razao_social:e.target.value})}
                  placeholder={form.tipo_pessoa==="PJ"?"Razão Social da empresa":"Nome completo"} />
              </div>

              {form.tipo_pessoa==="PJ" && (
                <div className="form-group full">
                  <label>Nome fantasia</label>
                  <input value={form.nome_fantasia} onChange={e=>setForm({...form,nome_fantasia:e.target.value})}
                    placeholder="Nome fantasia ou comercial" />
                </div>
              )}

              <div className="form-group">
                <label>E-mail *</label>
                <input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}
                  placeholder="contato@empresa.com.br" />
              </div>

              <div className="form-group">
                <label>Telefone</label>
                <input value={form.telefone} onChange={e=>setForm({...form,telefone:e.target.value})}
                  placeholder="(00) 00000-0000" />
              </div>

              {/* Endereço */}
              <Secao titulo="Endereço" icone="📍" />

              <div className="form-group">
                <label>CEP</label>
                <div style={{display:"flex",gap:8}}>
                  <input value={form.cep} onChange={e=>setForm({...form,cep:e.target.value})}
                    placeholder="00000-000" style={{flex:1}} />
                  <button type="button" className="btn btn-ghost" onClick={buscarCEP}
                    disabled={buscandoCEP} style={{flexShrink:0,fontSize:12}}>
                    {buscandoCEP?"🔍":"🔍 Buscar"}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label>Estado</label>
                <input value={form.estado} onChange={e=>setForm({...form,estado:e.target.value})}
                  placeholder="SP" maxLength={2} />
              </div>

              <div className="form-group full">
                <label>Logradouro</label>
                <input value={form.logradouro} onChange={e=>setForm({...form,logradouro:e.target.value})}
                  placeholder="Rua, Avenida, etc." />
              </div>

              <div className="form-group">
                <label>Número</label>
                <input value={form.numero} onChange={e=>setForm({...form,numero:e.target.value})}
                  placeholder="123" />
              </div>

              <div className="form-group">
                <label>Complemento</label>
                <input value={form.complemento} onChange={e=>setForm({...form,complemento:e.target.value})}
                  placeholder="Sala, Apto, etc." />
              </div>

              <div className="form-group">
                <label>Bairro</label>
                <input value={form.bairro} onChange={e=>setForm({...form,bairro:e.target.value})}
                  placeholder="Bairro" />
              </div>

              <div className="form-group">
                <label>Cidade</label>
                <input value={form.cidade} onChange={e=>setForm({...form,cidade:e.target.value})}
                  placeholder="Cidade" />
              </div>

              {/* Responsáveis */}
              {[1,2,3].map(n=>(
                <React.Fragment key={n}>
                  <Secao titulo={`Responsável ${n}${n===1?" (Principal)":""}`} icone="👤" />
                  <div className="form-group">
                    <label>Nome</label>
                    <input value={form[`resp${n}_nome`]} onChange={e=>setForm({...form,[`resp${n}_nome`]:e.target.value})}
                      placeholder={`Nome do responsável ${n}`} />
                  </div>
                  <div className="form-group">
                    <label>Telefone</label>
                    <input value={form[`resp${n}_telefone`]} onChange={e=>setForm({...form,[`resp${n}_telefone`]:e.target.value})}
                      placeholder="(00) 00000-0000" />
                  </div>
                  <div className="form-group full">
                    <label>E-mail</label>
                    <input type="email" value={form[`resp${n}_email`]} onChange={e=>setForm({...form,[`resp${n}_email`]:e.target.value})}
                      placeholder="email@empresa.com" />
                  </div>
                </React.Fragment>
              ))}

              {/* Responsável Financeiro */}
              <Secao titulo="Responsável Financeiro *" icone="💰" />

              <div className="form-group">
                <label>Nome *</label>
                <input value={form.fin_nome} onChange={e=>setForm({...form,fin_nome:e.target.value})}
                  placeholder="Nome do responsável financeiro" />
              </div>

              <div className="form-group">
                <label>Telefone *</label>
                <input value={form.fin_telefone} onChange={e=>setForm({...form,fin_telefone:e.target.value})}
                  placeholder="(00) 00000-0000" />
              </div>

              <div className="form-group full">
                <label>E-mails financeiros * (separados por ;)</label>
                <input value={form.fin_emails} onChange={e=>setForm({...form,fin_emails:e.target.value})}
                  placeholder="financeiro@empresa.com; cobranca@empresa.com" />
                <div style={{fontSize:10,color:"#475569",marginTop:3}}>
                  Esses e-mails receberão as faturas e cobranças do sistema
                </div>
              </div>

              <div className="form-group">
                <label>📅 Dia de vencimento da fatura</label>
                <select value={form.fin_vencimento} onChange={e=>setForm({...form,fin_vencimento:e.target.value})}>
                  {[5,10,15,20,25,30].map(d=><option key={d} value={d}>Dia {d}</option>)}
                </select>
              </div>

              <div className="form-group full">
                <label>Observações</label>
                <input value={form.observacoes} onChange={e=>setForm({...form,observacoes:e.target.value})}
                  placeholder="Observações gerais..." />
              </div>
            </div>

            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:20}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>
                💾 {editando?"Salvar alterações":"Cadastrar cliente"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
